import PropTypes from 'prop-types';
import { FaceFrownIcon } from '@heroicons/react/24/outline';

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

import { useTranslation } from '@app/i18n';

const StyledEmojiSadIcon = styled(FaceFrownIcon)(({ theme }) => {
  return {
    height: theme.spacing(4),
    width: theme.spacing(4),
  };
});

const SomethingWentWrong = ({ onClick = () => null }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      flexDirection="column"
    >
      <StyledEmojiSadIcon />

      <Box
        mt={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Typography variant="h6">
          {t('errors.somethingWentWrongRefresh.header')}
        </Typography>

        <Typography>
          {t('errors.somethingWentWrongRefresh.bodyPage')}
        </Typography>

        <Box p={2}>
          <Button
            startIcon={<RefreshIcon />}
            variant="contained"
            color="primary"
            disableElevation
            disableRipple
            onClick={() => onClick()}
          >
          {t('errors.somethingWentWrongRefresh.buttonTextPage')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

SomethingWentWrong.propTypes = {
  onClick: PropTypes.func,
};

export default SomethingWentWrong;
